import { AssignmentTurnedIn, Category, Dashboard, EventNote, ExpandLess, ExpandMore, Fingerprint, Home, InsertDriveFile, ManageAccounts, SettingsApplications, ViewModule, Window } from '@mui/icons-material';
import IconeMovimentosCnj from '../img/icones/IconeMovimentosCnj';
import { Collapse, ListItemButton } from '@mui/material';
import Divider from '@mui/material/Divider';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import { CSSObject, Theme, styled } from '@mui/material/styles';
import { action, computed, observable, makeObservable, reaction, IReactionDisposer } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import EscaninhoGabinete from '../img/icones-menu-lateral/EscaninhoGabinete';
import EscaninhoJulgamento from '../img/icones-menu-lateral/EscaninhoJulgamento';
import EscaninhoPauta from '../img/icones-menu-lateral/EscaninhoPauta';
import EscaninhoFiltrado from '../img/icones-menu-lateral/EscaninhoFiltrado';
import EscaninhoJustificativa from '../img/icones-menu-lateral/EscaninhoJustificativa';
import EscaninhoPeticoes from '../img/icones-menu-lateral/EscaninhoPeticoes';
import EscaninhoRedator from '../img/icones-menu-lateral/EscaninhoRedator';
import EscaninhoUsuario from '../img/icones-menu-lateral/EscaninhoUsuario';
import EscaninhoVistos from '../img/icones-menu-lateral/EscaninhoVistos';
import IcondeEstruturas from '../img/icones/IcondeEstruturas';
import IconeAM from '../img/icones/IconeAM';
import IconeAutotexto from '../img/icones/IconeAutotexto';
import IconeGE from '../img/icones/IconeGE';
import IconeTemas from '../img/icones/IconeTemas';
import UsuarioStore from '../store/UsuarioStore';
import FiltroStore from '../store/FiltroStore';
import LayoutStore from '../store/LayoutStore';
import RouterStore from '../store/RouterStore';
import TopBarStore from '../store/TopBarStore';
import Configuracao from '../utils/Configuracao';
import JustDev from '../utils/JustDev';
import { itensMenuPermitidos } from './MenuAcessoRapidoItens';
import './css/drawer.css';


// Largura do menu quando aberto (só ocorre no modo JustDev). Ampla o
// suficiente para não cortar rótulos longos como "Configurar Parâmetros do Usuário".
const drawerWidth = 380;
const ROTA_MINUTAS_DEVOLVIDAS = '/escaninho/filtrado?situacaoMinuta=70';

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: TopBarStore.menuAberto ? 'flex-end' : 'flex-start',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));


const openedMixin = (theme: Theme): CSSObject => ({
    position: 'static',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
    position: 'static',
    width: `calc(${theme.spacing(9)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(10)} + 8px)`,
    },
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
});


const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    height: '100%',
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    position: 'static',
    ...(open && {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme),
    }),
}));

interface IPropsMenuPrincipal {

}
class MenuPrincipal extends React.Component<IPropsMenuPrincipal> {
    open = TopBarStore.menuAberto;
    expand = false;
    private reactionRotaDisposer?: IReactionDisposer;

    setOpen = value => { this.open = value; };

    handleDrawerOpen = (event) => {
        TopBarStore.abreMenu(event);
        FiltroStore.drawerIsOpen = false;
        this.setOpen(true);
    };

    handleDrawerClose = () => {
        TopBarStore.fechaMenu();
        this.setOpen(false);
    };

    handleClick = () => {
        this.expand = !this.expand;
    };

    constructor(props: IPropsMenuPrincipal) {
        super(props);

        makeObservable(this, {
            open: observable,
            expand: observable,
            setOpen: action,
            handleDrawerOpen: action,
            handleDrawerClose: action,
            handleClick: action,
            usuario: computed
        });
    }

    componentDidMount() {
        this.reactionRotaDisposer = reaction(
            () => `${RouterStore.rotaAtual || ''}${RouterStore.location?.search || ''}`,
            () => {
                this.expand = /^\/escaninho2?\/(?!(?:dashboard|filtrado|assinatura)(?:\/|$))[^/]+/.test(RouterStore.rotaAtual || '')
                    || this.isItemSelecionado(ROTA_MINUTAS_DEVOLVIDAS);
            },
            { fireImmediately: true }
        );
    }

    componentWillUnmount() {
        this.reactionRotaDisposer?.();
    }

    get usuario() {
        return UsuarioStore.usuario;
    }

    irEndereco = (endereco, event) => {
        event.preventDefault();
        RouterStore.push(endereco);
        this.handleDrawerClose();
    }

    alternaMenu = (event) => {
        this.open ? this.handleDrawerClose() : this.handleDrawerOpen(event);
    }

    isItemSelecionado = (endereco: string) => {
        const [pathname, search] = endereco.split('?');
        const parametrosAtuais = new URLSearchParams(RouterStore.location?.search || '');
        const parametrosCorrespondem = Array.from(new URLSearchParams(search).entries())
            .every(([nome, valor]) => parametrosAtuais.get(nome) === valor);

        return (RouterStore.rotaAtual === pathname && parametrosCorrespondem)
            || (endereco === '/telaPrincipal' && RouterStore.rotaAtual === '/');
    }

    itemMenu = (texto, endereco, icone) => {
        const isSelected = this.isItemSelecionado(endereco);
        return (
            <ListItemButton 
                onClick={this.irEndereco.bind(this, endereco)}
                title={texto} aria-label={'Abrir ' + texto}
                sx={{
                    height: '48px',
                    borderLeft: 'solid 5px',
                    borderLeftColor: isSelected ? 'rgb(1, 87, 155)' : 'transparent',
                    backgroundColor: isSelected ? LayoutStore.backgroundMenuLateralSelecionado : 'transparent',
                    marginLeft: '6px',
                    marginBottom: '3.9px',
                    marginTop: '3.8px',
                    cursor: 'pointer',
                    color: LayoutStore.colorMenuLateralTexto,
                    '&:hover': {
                        backgroundColor: isSelected ? LayoutStore.backgroundMenuLateralSelecionado : LayoutStore.backgroundMenuLateralHover,
                    }
                }}
            >
                <ListItemIcon >
                    <div style={{ color: LayoutStore.colorIcon }}>
                        {icone}
                    </div>
                </ListItemIcon>
                <span style={{ marginLeft: '5px', color: LayoutStore.colorMenuLateralTexto }}>
                    {texto}
                </span>
            </ListItemButton>
        )
    }

    renderGE = () => {
        const rotasPermitidas = new Set(itensMenuPermitidos().map(item => item.route));
        const escaninhosSelecionado = [
            '/escaninho/usuario',
            '/escaninho/gerencial',
            '/escaninho/vistos',
            '/escaninho/pauta',
            '/escaninho/julgamento',
            '/escaninho/peticao',
            '/escaninho/redator-designado',
            '/escaninho/voto-vencido'
        ].includes(RouterStore.rotaAtual) || this.isItemSelecionado(ROTA_MINUTAS_DEVOLVIDAS);
        return (
            <>
                {this.itemMenu('Inicio', '/telaPrincipal', <Home />)}
                {this.itemMenu('Controle de Gabinete', '/controleGabinete', <ViewModule />)}
                <ListItemButton onClick={this.handleClick} style={{ height: '48px', borderLeft: 'solid 5px', borderLeftColor: escaninhosSelecionado ? 'rgb(1, 87, 155)' : 'transparent', marginLeft: '6px', marginBottom: '3.9px', marginTop: '3.8px', cursor: 'pointer' }} title={!this.expand ? 'Expandir submenu de escaninhos' : 'Recolher submenu de escaninhos'}>
                    <ListItemIcon sx={{ color: LayoutStore.colorIcon }}>
                        <EventNote />
                        {this.expand ? <ExpandLess /> : <ExpandMore />}
                    </ListItemIcon>
                </ListItemButton>
                <div style={{paddingLeft: '5px'}}>
                    <Collapse in={this.expand} timeout="auto" unmountOnExit sx={{
                        backgroundColor: LayoutStore.isTemaDark ? '#171717' : '#ECECEC',
                        '& .MuiListItemIcon-root svg text': {
                            fill: LayoutStore.isTemaDark ? LayoutStore.colorTextPrimary : '#01579B',
                        },
                    }}>
                        <List component="div">
                            {rotasPermitidas.has('/escaninho/usuario') && this.itemMenu('Escaninho do Usuário', '/escaninho/usuario', <EscaninhoUsuario />)}
                            {rotasPermitidas.has('/escaninho/gerencial') && this.itemMenu('Escaninho de Gabinete', '/escaninho/gerencial', <EscaninhoGabinete />)}
                            {rotasPermitidas.has('/escaninho/vistos') && this.itemMenu('Escaninho de Vistos', '/escaninho/vistos', <EscaninhoVistos />)}
                            {rotasPermitidas.has('/escaninho/pauta') && this.itemMenu('Escaninho de Pauta', '/escaninho/pauta', <EscaninhoPauta />)}
                            {rotasPermitidas.has('/escaninho/julgamento') && this.itemMenu('Escaninho de Julgamento', '/escaninho/julgamento', <EscaninhoJulgamento />)}
                            {rotasPermitidas.has('/escaninho/peticao') && this.itemMenu('Escaninho de Petições', '/escaninho/peticao', <EscaninhoPeticoes />)}
                            {rotasPermitidas.has('/escaninho/redator-designado') && this.itemMenu('Escaninho de Redator Designado', '/escaninho/redator-designado', <EscaninhoRedator />)}
                            {rotasPermitidas.has('/escaninho/voto-vencido') && this.itemMenu('Escaninho de Justificativa de Votos Vencidos', '/escaninho/voto-vencido', <EscaninhoJustificativa />)}
                            {rotasPermitidas.has(ROTA_MINUTAS_DEVOLVIDAS) && this.itemMenu('Minutas Devolvidas', ROTA_MINUTAS_DEVOLVIDAS, <EscaninhoFiltrado />)}
                        </List>
                    </Collapse>
                </div>
                {this.itemMenu('Edição de Categorias de Minutas', '/categoria', <Category />)}
                {this.itemMenu('Edição de Modelos de Minutas', '/modelosMinuta', <InsertDriveFile />)}
                {(UsuarioStore.usuarioTemPapel(Configuracao.PERFIL_ASSESSOR) || UsuarioStore.ehMagistrado || UsuarioStore.ehSecretario) &&
                    this.itemMenu('Escaninho de Assinatura', '/escaninho/assinatura', <Fingerprint />)
                }
                {(UsuarioStore.usuarioTemPapel(Configuracao.PERFIL_ASSESSOR) || UsuarioStore.ehMagistrado) &&
                    this.itemMenu('Gerenciador de Acervo', '/escaninho/dashboard', <Dashboard />)
                }
                {this.itemMenu('Hermes', '/assistenteMinutas', <IconeAM />)}
                {this.itemMenu('Minutas Assinadas', '/minutasAssinadas', <AssignmentTurnedIn />)}
                {UsuarioStore.usuarioTemPapel(Configuracao.SUPER_ADMINISTRADOR) &&
                    this.itemMenu('Configurar Parâmetros do Sistema', '/parametroSistema', <SettingsApplications />)
                }
                {UsuarioStore.usuarioTemPapel(Configuracao.SUPER_ADMINISTRADOR) &&
                    this.itemMenu('Movimentos CNJ', '/movimentosCnj', <IconeMovimentosCnj width={42} height={24} fill={LayoutStore.colorIcon} style={{ marginLeft: '-4px' }} />)
                }
                {/*
                Retirada a duplicação de configuração de parâmetros.
                TODO: Revisar para ver se tem alguma função além.
                {UsuarioStore.usuarioTemPapel(Configuracao.SUPER_ADMINISTRADOR) &&
                    this.itemMenu('Configurar Parâmetros', '/parametroGabinete', <BuildIcon />)
                }
                */}
                {this.itemMenu('Configurar Parâmetros do Usuário', '/parametroUsuario', <ManageAccounts />)}
            </>
        );
    }

    renderHermes = () => {
        return (
            <>
                {this.itemMenu('Inicio', '/assistenteMinutas', <Home />)}
                {this.itemMenu('Temas', '/assistenteMinutas/temas', <IconeTemas />)}
                {this.itemMenu('Modelos de Temas', '/assistenteMinutas/modelosTemas', <InsertDriveFile />)}
                {this.itemMenu('Estruturas', '/assistenteMinutas/estruturas', <IcondeEstruturas />)}
                {this.itemMenu('Autotexto', '/assistenteMinutas/autotextos', <IconeAutotexto />)}
                {this.itemMenu('Gerenciador de Minutas', '/assistenteMinutas/gerenciarMinutas', <Window />)}
                {this.itemMenu('Gabinete Eletrônico', '/telaPrincipal', <IconeGE />)}
            </>
        );
    }

    render() {

        return (

            <Drawer
                open={TopBarStore.justDevAberto}
                onClose={TopBarStore.fechaMenu}
                variant="permanent"
                slotProps={{
                    paper: {
                        sx: {
                            backgroundColor: LayoutStore.backgroundMenuLateral,
                        }
                    }
                }}
            >

                <div id='drawer' className='esconderImpressao barraLateralMinWidth barraLateralResolucao' style={{ minHeight: '43px' }}>
                    <JustDev >
                        <List>
                            {!RouterStore.isAM ?
                                this.renderGE()
                                :
                                this.renderHermes()
                            }
                            {/* {this.itemMenu('Sobre o GE', '/sobre', <FreeBreakfast />)} */}
                        </List>
                        <Divider />
                        <Divider />
                    </JustDev>
                </div>
            </Drawer>

        );
    }
}

export default observer(MenuPrincipal);
